import React, { useEffect } from "react";
import { useState } from "react";
import FoodDataService from "../services/foods.services";
import { Form, Button, Row, Col, Card } from "react-bootstrap";
import Alert from "react-bootstrap/Alert";
import { Link } from "react-router-dom";
import { db } from "../firebase";

import { query, collection, getDocs, where } from "firebase/firestore";

const AddFoodComponent = (props) => {
    const [brand, setBrand] = useState(props.food.brand);
    const [food, setFood] = useState(props.food.food);
    const [amount, setAmount] = useState(Number(props.food.amount));
    const [unitOfMeasurement, setUnitOfMeasurement] = useState(props.food.unitOfMeasurement);
    const [category, setCategory] = useState(1);
    const [countryOfOrigin, setCountryOfOrigin] = useState(props.food.countryOfOrigin);
    const [gtin, setGtin] = useState(Number(props.food.gtin));

    const [displayNutrients, setDisplayNutrients] = useState(false);

    const [energy, setEnergy] = useState(0);
    const [calories, setCalories] = useState(0);
    const [fat, setFat] = useState(0);
    const [saturatedFat, setSaturatedFat] = useState(0);
    const [carbohydrates, setCarbohydrates] = useState(0);
    const [sugars, setSugars] = useState(0);
    const [dietaryFiber, setDietaryFiber] = useState(0);
    const [protein, setProtein] = useState(0);
    const [salt, setSalt] = useState(0);

    const [ingredients, setIngredients] = useState([]);
    const [allergens, setAllergens] = useState([]);
    const [chains, setChains] = useState([]);

    const [errorMessages, setErrorMessages] = useState([]);
    const [successMessages, setSuccessMessages] = useState([]);

    useEffect(() => {
        setBrand(props.food.brand);
        setFood(props.food.food)
        setGtin(Number(props.food.gtin))
        setCountryOfOrigin(props.food.countryOfOrigin)
        setAmount(Number(props.food.amount))
        setUnitOfMeasurement(props.food.unitOfMeasurement)
    }, [props]);

    const handleRemoveIngredient = (e) => {
        const name = e.target.getAttribute("name");
        setIngredients(ingredients.filter((ingredient) => ingredient !== name));
    };

    const handleRemoveAllergen = (e) => {
        const name = e.target.getAttribute("name");
        setAllergens(allergens.filter((allergen) => allergen !== name));
    };

    const handleRemoveChain = (e) => {
        const name = e.target.getAttribute("name");
        setChains(chains.filter((chain) => chain !== name));
    };

    const foodIsNew = async () => {
        const q = query(collection(db, "foods"), where("gtin", "==", gtin));
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
            return true;
        } else {
            return false;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newFood = {
            brand,
            food,
            amount,
            unitOfMeasurement,
            category,
            countryOfOrigin,
            gtin,
            nutrients: {
                energy,
                calories,
                fat,
                saturatedFat,
                carbohydrates,
                sugars,
                dietaryFiber,
                protein,
                salt,
            },
            ingredients,
            allergens,
            chains,
        };

        if (
            brand &&
            food &&
            unitOfMeasurement &&
            category &&
            countryOfOrigin &&
            gtin
        ) {
            if (await foodIsNew()) {
                try {
                    if (
                        window.confirm(
                            "Er du sikker på at du vil legge til: " +
                            food +
                            " fra " +
                            brand +
                            "?"
                        )
                    ) {
                        await FoodDataService.addFoods(newFood);
                        setSuccessMessages((successMessages) => [
                            ...successMessages,
                            `${food} ble lagt til i databasen!`,
                        ]);
                        document.getElementById("searchGtin").value = "";
                        setGtin(0);
                        setFood("");
                        setBrand("");
                        setCountryOfOrigin("");
                        setAllergens([]);
                        setErrorMessages([]);
                    }
                } catch (err) {
                    console.log(err);
                }
            } else {
                setErrorMessages((errorMessages) => [
                    ...errorMessages,
                    "Matvaren er allerede lagt til i databasen",
                ]);
            }
        } else {
            setErrorMessages((errorMessages) => [
                ...errorMessages,
                "Noen felter inneholder feil",
            ]);
        }
    };

    return (
        <Card className="stickyContainer">
            <div className="p-4 text-center overflow-auto">
                <h2 className="mb-3">Legg til matvare</h2>
                <hr />
                <div className="mb-3">
                    {successMessages.map((successMessage) => (
                        <Alert
                            key={successMessage}
                            className="end-0"
                            name={successMessage}
                            variant="success"
                        >
                            {successMessage}
                        </Alert>
                    ))}
                </div>
                <div className="mb-3">
                    {errorMessages.map((errorMessage) => (
                        <Alert
                            key={errorMessage}
                            className="end-0"
                            name={errorMessage}
                            variant="danger"
                        >
                            {errorMessage}
                        </Alert>
                    ))}
                </div>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="brand">
                                <Form.Label>Merke:</Form.Label>
                                <Form.Control
                                    value={brand}
                                    type="text"
                                    onChange={(e) =>
                                        setBrand(e.target.value.toLowerCase())
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="foodItem">
                                <Form.Label>Matvare:</Form.Label>
                                <Form.Control
                                    value={food}
                                    type="text"
                                    onChange={(e) =>
                                        setFood(e.target.value.toLowerCase())
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                        <Form.Group
                                controlId="amount"
                            >
                                <Form.Label>Mengde:</Form.Label>
                                <Form.Control
                                    value={amount}
                                    type="text"
                                    onChange={(e) => {
                                        if (e.target.value.includes(",")) {
                                            setAmount(
                                                parseFloat(
                                                    e.target.value.replace(
                                                        ",",
                                                        "."
                                                    )
                                                )
                                            );
                                        } else {
                                            setAmount(
                                                parseFloat(e.target.value)
                                            );
                                        }
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                        <Form.Group
                                controlId="unitOfMeasurement"
                            >
                                <Form.Label>Enhet:</Form.Label>
                                <Form.Select
                                    value={unitOfMeasurement}
                                    onChange={(e) =>
                                        setUnitOfMeasurement(e.target.value)
                                    }
                                >
                                    <option value="stk">stk</option>
                                    <option value="mg">mg (milligram)</option>
                                    <option value="g">g (gram)</option>
                                    <option value="kg">kg (kilogram)</option>
                                    <option value="ml">ml (milliliter)</option>
                                    <option value="dl">dl (desiliter)</option>
                                    <option value="l">l (liter)</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Form.Group className="mb-3" controlId="category">
                        <Form.Label>Kategori:</Form.Label>
                        <Form.Select
                            onChange={(e) =>
                                setCategory(parseInt(e.target.value))
                            }
                            defaultValue="1"
                        >
                            <option value="1">
                                1 - Melk og melkeprodukter
                            </option>
                            <option value="2">2 - Egg</option>
                            <option value="3">3 - Fjørfe og kjøtt</option>
                            <option value="4">4 - Fisk og skalldyr</option>
                            <option value="5">
                                5 - Korn- og bakevarer, frø og nøtter
                            </option>
                            <option value="6">6 - Grønnsaker</option>
                            <option value="7">
                                7 - Sukker og søte produkter
                            </option>
                            <option value="8">
                                8 - Margarin, smør, matolje o.l.
                            </option>
                            <option value="9">9 - Drikke</option>
                            <option value="10">
                                10 - Diverse retter, produkter og ingredienser
                            </option>
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="countryOfOrigin">
                        <Form.Label>Opprinnelsesland:</Form.Label>
                        <Form.Control
                            value={countryOfOrigin}
                            type="text"
                            onChange={(e) =>
                                setCountryOfOrigin(e.target.value.toLowerCase())
                            }
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="gtin">
                        <Form.Label>GTIN (strekkode):</Form.Label>
                        <Form.Control
                            placeholder={gtin.toString()}
                            type="text"
                            onChange={(e) => {
                                setGtin(parseInt(e.target.value));
                            }}
                        />
                    </Form.Group>

                    {displayNutrients && (
                        <div>
                            <h2 className="mb-3 p-3">
                                Næringsinnhold per 100g
                            </h2>
                            <hr />
                            <Form.Group className="mb-3" controlId="energy">
                                <Form.Label>Energi (kJ):</Form.Label>
                                <Form.Control
                                    type="text"
                                    disabled
                                    onChange={(e) =>
                                        setEnergy(parseFloat(e.target.value))
                                    }
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="calories">
                                <Form.Label>Kalorier (kcal):</Form.Label>
                                <Form.Control
                                    type="text"
                                    disabled
                                    onChange={(e) =>
                                        setCalories(parseFloat(e.target.value))
                                    }
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="fat">
                                <Form.Label>Fett:</Form.Label>
                                <Form.Control
                                    type="text"
                                    disabled
                                    onChange={(e) =>
                                        setFat(parseFloat(e.target.value))
                                    }
                                />
                            </Form.Group>

                            <Form.Group
                                className="mb-3"
                                controlId="saturatedFat"
                            >
                                <Form.Label>Mettet fett:</Form.Label>
                                <Form.Control
                                    type="text"
                                    disabled
                                    onChange={(e) =>
                                        setSaturatedFat(
                                            parseFloat(e.target.value)
                                        )
                                    }
                                />
                            </Form.Group>

                            <Form.Group
                                className="mb-3"
                                controlId="carbohydrates"
                            >
                                <Form.Label>Karbohydrater:</Form.Label>
                                <Form.Control
                                    type="text"
                                    disabled
                                    onChange={(e) =>
                                        setCarbohydrates(
                                            parseFloat(e.target.value)
                                        )
                                    }
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="sugars">
                                <Form.Label>Sukkerarter:</Form.Label>
                                <Form.Control
                                    type="text"
                                    disabled
                                    onChange={(e) =>
                                        setSugars(parseFloat(e.target.value))
                                    }
                                />
                            </Form.Group>

                            <Form.Group
                                className="mb-3"
                                controlId="dietaryFibers"
                            >
                                <Form.Label>
                                    Kostfiber (kan sløyfes):
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    disabled
                                    onChange={(e) =>
                                        setDietaryFiber(
                                            parseFloat(e.target.value)
                                        )
                                    }
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="protein">
                                <Form.Label>Protein:</Form.Label>
                                <Form.Control
                                    type="text"
                                    disabled
                                    onChange={(e) =>
                                        setProtein(parseFloat(e.target.value))
                                    }
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="salt">
                                <Form.Label>Salt:</Form.Label>
                                <Form.Control
                                    type="text"
                                    disabled
                                    onChange={(e) =>
                                        setSalt(parseFloat(e.target.value))
                                    }
                                />
                            </Form.Group>

                            <h2 className="mb-3 p-3">Ingredienser</h2>

                            <Form.Group className="mb-3">
                                <Form.Control
                                    className="mb-3"
                                    type="text"
                                    id="ingredientInput"
                                    disabled
                                />
                                <Button
                                    variant="light"
                                    disabled
                                    className="mb-3 col-12 border border-dark"
                                    onClick={() => {
                                        if (
                                            ingredients.indexOf(
                                                document
                                                    .getElementById(
                                                        "ingredientInput"
                                                    )
                                                    .value.toLowerCase()
                                            ) > -1
                                        ) {
                                            alert(
                                                document
                                                    .getElementById(
                                                        "ingredientInput"
                                                    )
                                                    .value.toLowerCase() +
                                                " er allerede lagt til!"
                                            );
                                        } else {
                                            setIngredients([
                                                ...ingredients,
                                                document
                                                    .getElementById(
                                                        "ingredientInput"
                                                    )
                                                    .value.toLowerCase(),
                                            ]);
                                            document.getElementById(
                                                "ingredientInput"
                                            ).value = "";
                                        }
                                    }}
                                >
                                    Legg til ingrediens
                                </Button>
                            </Form.Group>

                            <div className="mb-3">
                                {ingredients.map((ingredient) => (
                                    <div key={ingredient}>
                                        <Button
                                            name={ingredient}
                                            variant="danger"
                                            onClick={handleRemoveIngredient}
                                        >
                                            Fjern {ingredient}
                                        </Button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    <h2 className="m-4">Allergener</h2>
                    <Form.Group className="mb-3">
                        <Form.Select
                            className="mb-3"
                            id="allergenForm"
                            defaultValue="gluten"
                        >
                            <option value="gluten">Gluten</option>
                            <option value="shellfish">Skalldyr</option>
                            <option value="eggs">Egg</option>
                            <option value="fish">Fisk</option>
                            <option value="peanuts">Peanøtter</option>
                            <option value="soy">Soya</option>
                            <option value="milk">Melk</option>
                            <option value="treeNuts">Andre nøtter</option>
                            <option value="celery">Selleri</option>
                            <option value="mustard">Sennep</option>
                            <option value="sesame">Sesamfrø</option>
                            <option value="sulphites">
                                Svoveldioksid og sulfitter
                            </option>
                            <option value="lupin">Lupin</option>
                            <option value="molluscs">Bløtdyr</option>
                        </Form.Select>
                        <Row>
                            <Col>
                                <Button
                                    variant="light"
                                    className="mb-3 col-12 border border-dark"
                                    onClick={() => {
                                        if (
                                            allergens.indexOf(
                                                document.getElementById("allergenForm")
                                                    .value
                                            ) > -1
                                        ) {
                                            alert(
                                                document.getElementById("allergenForm")
                                                    .value + " er allerede lagt til!"
                                            );
                                        } else {
                                            setAllergens((allergens) => [
                                                ...allergens,
                                                document.getElementById("allergenForm")
                                                    .value,
                                            ]);
                                        }
                                    }}
                                >
                                    Legg til allergen
                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    variant="danger"
                                    className="mb-3 col-12 border border-dark"
                                    onClick={() => {
                                        setAllergens([]);
                                    }}
                                >
                                    Fjern alle allergener
                                </Button>
                            </Col>
                        </Row>


                    </Form.Group>

                    <div>
                        {allergens.map((allergen) => (
                            <div key={allergen}>
                                <Button
                                    className="end-0"
                                    name={allergen}
                                    variant="danger"
                                    onClick={handleRemoveAllergen}
                                >
                                    Fjern {allergen}
                                </Button>
                            </div>
                        ))}
                    </div>

                    <h2 className="m-4">Butikker</h2>
                    <Form.Group className="mb-3">
                        <Form.Select
                            className="mb-3"
                            id="chainForm"
                            defaultValue="meny"
                        >
                            <option value="kiwi">Kiwi</option>
                            <option value="meny">Meny</option>
                            <option value="joker">Joker</option>
                            <option value="bunnpris">Bunnpris</option>
                            <option value="spar">Spar</option>
                            <option value="rema">Rema</option>
                            <option value="obs">Coop Obs</option>
                            <option value="extra">Coop Extra</option>
                        </Form.Select>
                        <Row>
                            <Col>
                                <Button
                                    variant="light"
                                    className="mb-3 col-12 border border-dark"
                                    onClick={() => {
                                        if (
                                            chains.indexOf(
                                                document.getElementById("chainForm")
                                                    .value
                                            ) > -1
                                        ) {
                                            alert(
                                                document.getElementById("chainForm")
                                                    .value + " er allerede lagt til!"
                                            );
                                        } else {
                                            setChains((chains) => [
                                                ...chains,
                                                document.getElementById("chainForm")
                                                    .value,
                                            ]);
                                        }
                                    }}
                                >
                                    Legg til butikk
                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    variant="danger"
                                    className="mb-3 col-12 border border-dark"
                                    onClick={() => {
                                        setChains([]);
                                    }}
                                >
                                    Fjern alle butikker
                                </Button>
                            </Col>
                        </Row>
                    </Form.Group>

                    <div className="mb-3">
                        {chains.map((chain) => (
                            <div key={chain}>
                                <Button
                                    className="end-0"
                                    name={chain}
                                    variant="danger"
                                    onClick={handleRemoveChain}
                                >
                                    Fjern {chain}
                                </Button>
                            </div>
                        ))}
                    </div>

                    <hr />
                    <Button className="w-100" variant="primary" type="submit">
                        Legg til matvare
                    </Button>
                </Form>
            </div>
        </Card>
    );
};

export default AddFoodComponent;